module.exports = __webpack_public_path__ + "img/2f_r_sobaichi.9c2aaae4.jpg";